import React from "react";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { useDispatch, useSelector } from "react-redux";
import ListingCheckUi from "./ListingCheck/ListingCheckUi";

const ListingCheck = () => {
    const userStateDetails = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();

    return (
        <StyledMainBox component="main">
            <h1>Listing Check</h1>
            <ListingCheckUi />
        </StyledMainBox>
    );
};

export default AccessControl(ListingCheck, ["listing_check_can_edit"], [], ["listingCheck"]);
